<template>
 <!-- select number qty -->
    <div>
           <h2 class="Select_size_title">{{get_local_string.string_98}} 
                                    <span class="bolletsNode">1</span>
                                </h2>
                                <div class="priceAndAmount">
                                    <div class="number">
                                        <span @click="minus()" class="minus"><i class="fas fa-minus"></i></span>
                                        <input v-model="counterData.qty" type="text" value="1">
                                        <span @click="plus()" class="plus"><i class="fas fa-plus"></i></span>
                                    </div>
                                    </div>
    </div>
</template>
<script>
 import $ from 'jquery';
 import { mapGetters } from 'vuex';
export default {
name:'counterTil',
props:['counterData' , 'extra_sum' , 'getbox_details'],
methods:{
     plus() {
                this.counterData.qty++;
                // ### change Price Total
                // console.log(this.getbox_details)
                if(this.getbox_details.dough.length>0)
                {
                    // console.log('yes has dought');
                     this.counterData.price = ($(`.dough-${this.counterData.dough_id}.active`).find('input').attr('data-price') * this.counterData.qty) + parseFloat(this.extra_sum);
                }
                else
                {
                    // console.log('no has dought');
                    this.counterData.price = this.getbox_details.price * this.counterData.qty;
                }
               
            },
            minus() {
                if (this.counterData.qty > 1) {
                    this.counterData.qty--;
                    // ### change Price Total
                    if(this.getbox_details.dough.length>0)
                {
                    // console.log('yes has dought');
                     this.counterData.price = ($(`.dough-${this.counterData.dough_id}.active`).find('input').attr('data-price') * this.counterData.qty) + parseFloat(this.extra_sum);
                }
                else{
                    // console.log('no has dought');
                    this.counterData.price = this.getbox_details.price * this.counterData.qty;
                }
                }
            }
            ,
},
 computed:{
        ...mapGetters({
               get_local_string:'get_local_string'
        })
    },
                      mounted(){
         document.body.classList.add('tilpasePage');
    },
    destroyed(){
      document.body.classList.remove('tilpasePage');
    }
    
}
</script>


<style lang="scss" scoped>
  .Select_size_title {
        font-size: 14px;
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
        color: black;
        margin-top: 25px;
    }
   .priceAndAmount {
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            margin: 20px 0px 10px;
            align-items: flex-start;
            border: 1px solid var(--active_color);
            padding: 10px 14px 36px;
            border-radius: 10px;
            color: var(--active_color);

            .number {
                position: relative;
                background-color: transparent;
            }

            .minus,
            .plus {
                width: 50px;
                height: 50px;
                line-height: 15px;
                background: var(--active_color);
                border-radius: 50%;
                font-size: 20px;
                border: 1px solid var(--active_color);;
                text-align: center;
                cursor: pointer;
                transition: all 0.5s ease-in-out;
                margin-right: 15px;
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
        
                i {
                   color: black;
                    padding-left: 2px;
                }
            }

            // .minus::after {
            //     content: 'minus';
            //     position: absolute;
            //     font-size: 14px;
            //     left: 0;
            //     right: 0;
            //     bottom: -24px;
            //     line-height: 20px;
            //     color: black;
            // }

            // .plus::after {
            //     content: 'plus';
            //     position: absolute;
            //     font-size: 14px;
            //     left: 0;
            //     right: 0;
            //     bottom: -24px;
            //     line-height: 20px;
            //     color: black;
            // }

            // .number::after {
            //     content: 'quantiy';
            //     position: absolute;
            //     font-size: 14px;
            //     left: -10px;
            //     right: 0;
            //     bottom: -28px;
            //     line-height: 20px;
            //     margin-left: auto;
            //     margin-right: auto;
            //     text-align: center;
            //     color: black;
            // }

            .number input {
                height: 50px;
                width: 50px;
                text-align: center;
                font-size: 20px;
                border: 1px solid var(--active_color);
                color: black;
                background: var(--active_color);
                border-radius: 50%;
                display: inline-block;
                vertical-align: middle;
                margin-right: 15px;
            }
        }
         .bolletsNode {
        border-radius: 500%;
        background: var(--active_color);
        color: black;
        height: 30px;
        width: 30px;
        transition: all 500ms ease-in-out;
        text-align: center;
        line-height: 30px;
        margin-left: -25px;
        position: absolute;
        left: 0px;
        margin-top: -8px;
    }
</style>